import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {RmOrderService} from '../../../services/rm-order.service';
import {RmConfirmationService} from '../../../services/rm-confirmation.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-rm-loader',
    templateUrl: './rm-loader.component.html',
    styleUrls: ['./rm-loader.component.css', '../../../../../assets/css/rm-theme.css'],
    standalone: false
})
export class RmLoaderComponent implements OnInit, OnDestroy {
    @Output() onPreloadingComplete = new EventEmitter<boolean>();
    @Input() set startGetStatus(value) {
        if (value) {
            this.initialTime = value;
            this.initOrder();
        }
    }

    public title = 'Activando los servicios';
    public description = 'Mantengase a la espera este proceso puede durar hasta varios segundos';
    public progress = 0;
    public finished = false;
    public httpError = false;
    private orderId: any;
    private order: any;
    private initialTime = 0;
    private firstSection = 0.75;
    private secondSection = 0.25;
    private firstTimeLimit = 30000;
    private secondTimeLimit = 60000;
    private timeBetweenRequests = 2000;
    private allSubscription: Subscription[] = [];

    constructor(
        private orderService: RmOrderService, 
        private confirmationService: RmConfirmationService
    ) { }

    ngOnInit(): void {
        this.allSubscription.push(this.confirmationService.getHttpError()
            .subscribe((data: boolean) => {
                this.httpError = data;
            })
        );
    }

    initOrder() {
        this.allSubscription.push(this.orderService.getOrder()
            .subscribe((data: any) => {
                if (data != null) {
                    this.orderId = data.order_id;
                    if (this.initialTime === 0) {
                        this.initialTime = new Date().getTime();
                    }                    
                    if (this.orderId) {
                        this.getOrder();
                    }                    
                }
            })
        );
    }

    getOrder() {
        if (this.initialTime === 0) {
            this.initialTime = new Date().getTime();
        }

        this.orderService.getOrderFromService(this.orderId)
            .subscribe((data: any) => {
                this.order = data.msg;
                const now = new Date().getTime();
                const timeDifference = now - this.initialTime;

                if (timeDifference <= this.firstTimeLimit) {
                    this.progress = (timeDifference * 100 / this.firstTimeLimit) * this.firstSection;
                } else if (timeDifference <= this.secondTimeLimit) {
                    this.progress = 75 + ((timeDifference * 100 / this.secondTimeLimit) * this.secondSection);
                } else {
                    this.progress = 100;
                    this.finished = true;
                    this.onPreloadingComplete.emit(true);
                    return;
                }
                this.checkStatus();
            });
    }

    checkStatus() {
        if (this.order && this.order.exit_progress_bar) {
            console.log('order complete');
            this.progress = 100;
            this.finished = true;
            this.onPreloadingComplete.emit(true);
        } else if (!this.httpError && !this.finished) {
            console.log('Se volverá a consultar el status en ' + this.timeBetweenRequests + ' milisegundos');
            setTimeout(() => this.getOrder(), this.timeBetweenRequests);
        } else if (this.httpError) {
            this.progress = 0;
            this.initialTime = 0;
            console.error('Error HTTP');
        } else if (this.finished) {
            this.progress = 0;
            this.initialTime = 0;
            console.log('Order complete');
        }
    }

    ngOnDestroy() {
        if (this.allSubscription && this.allSubscription.length) {
            this.allSubscription.map(subs => subs.unsubscribe());
        }
    }
}
